import { request } from '@/utils/request';
import * as url from '@/src/constant';

const ROUTE_CONTRACT = '/pages/contract/index';

/**
 * 获取资质签约列表
 * @param query
 * @returns {Promise<TResult>}
 */
export function fetchContractList(query) {
  return request({
    url: url.QUERY_CONTRACT_PAGINATION_URL,
    query,
    method: "POST",
    returnUrl: ROUTE_CONTRACT
  });
}

// 查询资质签约准备信息接口
export function fetchSignPrepareInfo(query) {
  return request({
    url: url.QUERY_SIGN_PREPAREINFO_URL,
    query,
    method: "POST",
    returnUrl: ROUTE_CONTRACT
  });
}

// 签约接口
export function fetchSignResult(query) {
  return request({
    url: url.SIGN_URL,
    query,
    method: "POST",
    returnUrl: ROUTE_CONTRACT,
    // message不需要处理
    fetchOptions: { showToast: false }
  });
}

// 获取电子合同签约链接
export function queryContractSignUrl(query) {
  return request({
    url: url.QUERY_CONTRACT_SIGN_URL,
    query,
    method: "POST",
    returnUrl: ROUTE_CONTRACT,
  });
}

// 获取电子合同查看链接
export function queryContractViewUrl(query) {
  return request({
    url: url.QUERY_CONTRACT_VIEW_URL,
    query,
    method: "POST",
    returnUrl: ROUTE_CONTRACT,
  });
}
